'use client'

import { Button } from '@chain-zen/ui'
import React from 'react'

interface IStandardSectionProps {
  buttonName?: string
  buttonVariant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link'
  children?: React.ReactNode
  multipleFields?: { fieldName: string; value?: string }[]
  onClick?: () => void
  singleField?: string
}

/**
 * Standard section component for displaying fields and actions
 * Used within the Section component
 */
export const StandardSection = ({
  buttonName,
  buttonVariant = 'secondary',
  children,
  multipleFields,
  onClick,
  singleField
}: IStandardSectionProps) => (
  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
    <div className="space-y-2 w-full sm:w-2/3">
      {!!singleField && (
        <p className="text-sm">
          <span className="text-muted-foreground">{singleField}</span>
        </p>
      )}
      {!!multipleFields &&
        multipleFields.map((field, index) => (
          <div key={index} className="flex flex-col sm:flex-row gap-1 sm:gap-2">
            <span className="text-sm font-medium">{field.fieldName}</span>
            <span className="text-sm text-muted-foreground">{field.value}</span>
          </div>
        ))}
    </div>
    <div>
      {buttonName && onClick ? (
        <Button variant={buttonVariant} size="sm" onClick={onClick}>
          {buttonName}
        </Button>
      ) : (
        children
      )}
    </div>
  </div>
)
